import Turnstile from "react-turnstile";

const BotVerification = ({ onVerify }) => {
  return (
    <Turnstile
      sitekey="0x4AAAAAAEfJhX9uGjeBiRH3"
    //   sitekey="1x00000000000000000000AA"
      onVerify={onVerify}
      onExpire={() => onVerify(null)}
      onError={() => onVerify(null)}
    />
  );
};

export default BotVerification;